import { localStorage } from 'dibs-browser-storage';
import {
    STORAGE_KEY_PDP_VISITS,
    UNIQUE_PDP_VIEW_COUNT,
    TWO_WEEKS_PERIOD,
    pdpInfoType,
    pdpType,
} from './pdpSharedConsumerSourcingHelpersConstants';
import { getUserPdpVisitsInfo } from './pdpSharedConsumerSourcingPdpInfoHelper';

export const removeUserPdpVisitsInfo: ({ userId }: { userId: string }) => pdpType[] = ({
    userId,
}) => {
    const { userPdpVisitsInfo, userIndex } = getUserPdpVisitsInfo({ userId });
    userPdpVisitsInfo.splice(userIndex, 1);
    return userPdpVisitsInfo;
};

/**
 * Determines whether a consumer user has reached the 25th unique pdp that has a value over 5000USD
 * An example value would look like [{"userId":"12345","pdpInfo":[{"itemId":"f_12345"}]}]
 * @param {string} itemId
 * @param {string} userId
 * @param {number} itemPrice
 * @returns {boolean}
 */
export const evaluatePdpVisit = ({
    itemId,
    userId,
    itemPrice,
}: {
    itemId: string;
    userId: string;
    itemPrice: number;
}): boolean => {
    const { userPdpVisitsInfo, userIndex } = getUserPdpVisitsInfo({ userId });
    const currentTime = Date.now();

    // if the user has previously visite other pages that is eligible for the consumer sourcing modal
    if (userIndex !== -1) {
        const userPdp = userPdpVisitsInfo.splice(userIndex, 1)[0];
        const pdpIndex = userPdp?.pdpInfo?.findIndex((pdp: pdpInfoType) => pdp?.itemId === itemId);

        // if the pdp in view has been visited by the user before, increment the count but do not create new entry
        if (pdpIndex !== -1) {
            const pdp = userPdp.pdpInfo.splice(pdpIndex, 1)[0];
            userPdp.pdpInfo.push({
                ...pdp,
                count: pdp.count + 1,
                lastView: currentTime,
            });
        } else {
            // if the pdp has not been visited by the user before, add the info the pdpInfo of the user
            userPdp.pdpInfo.push({
                itemId,
                itemPrice,
                count: 1,
                lastView: currentTime,
            });
        }

        //remove any pdp that was visited outside the two weeks window
        const pdpTwoWeeksRecord = userPdp.pdpInfo.filter(
            (pdp: pdpInfoType) => currentTime - pdp.lastView <= TWO_WEEKS_PERIOD
        );
        const updatedUserPdp = {
            ...userPdp,
            pdpInfo: pdpTwoWeeksRecord,
        };
        userPdpVisitsInfo.push(updatedUserPdp);
        localStorage.setItem(STORAGE_KEY_PDP_VISITS, userPdpVisitsInfo);
        return pdpTwoWeeksRecord.length >= UNIQUE_PDP_VIEW_COUNT;
    } else {
        //if it is the first time a user has seen a pdp eligible for consumer sourcing modal
        userPdpVisitsInfo.push({
            userId: userId,
            pdpInfo: [{ itemId, itemPrice, count: 1, lastView: currentTime }],
        });
        localStorage.setItem(STORAGE_KEY_PDP_VISITS, userPdpVisitsInfo);
    }

    return false;
};
